import { Inbox } from "lucide-react";

// Tutarlı boş / sonuç yok / hata durumu bileşeni (yoğun veri ekranları için).
export function EmptyState({ icon: Icon = Inbox, title, hint, action, testid = "empty-state", compact = false, tone = "slate" }) {
  const toneCls = tone === "error"
    ? "bg-red-50 text-red-400"
    : tone === "success"
    ? "bg-emerald-50 text-emerald-500"
    : "bg-slate-100 text-slate-400";
  return (
    <div data-testid={testid} className={`flex flex-col items-center justify-center text-center ${compact ? "py-8" : "py-14"}`}>
      <span className={`mb-3 flex h-12 w-12 items-center justify-center rounded-full ${toneCls}`}><Icon className="h-6 w-6" /></span>
      {title && <p className="font-heading text-sm font-semibold text-slate-700">{title}</p>}
      {hint && <p className="mt-1 max-w-sm text-xs text-slate-400">{hint}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export default EmptyState;
